<template>
  <person-intro :intro="data"></person-intro>
</template>
<script>
import PersonIntro from 'components/common/PersonIntro.vue'


export default {
  data() {
    return {
      data: [{ tid: '322292', type: 'author', title: 'Catherine Wong', bio: 'Catherine Wong is a reporter with the South China Morning Post in Beijing, where she focuses on China’s diplomacy and defense policy. Follow her on Twitter @catherinewongbj', links: { twitter: 'http://www.twitter.com/catherinewongbj', email: 'catherine.wong@scmp.com', facebook: 'www.facebook.com', instagram: 'ig.com' }, images: [{ style_140x140: 'https://cdn3.i-scmp.com/sites/default/files/styles/140x140/public/catherine-wong.png?itok=9kAtER2Y', style_square: 'https://cdn1.i-scmp.com/sites/default/files/styles/square/public/catherine-wong.png?itok=tPKOfQRC', full: 'https://cdn3.i-scmp.com/sites/default/files/catherine-wong.png' }], url: 'http://scmpdevuat.scmp.com/author/catherine-wong', relative_url: '/author/catherine-wong' }],
    }
  },
  components: {
    PersonIntro,
  },
}
</script>

<style lang="scss" scoped>
.person-intro {
  padding: 47px;
}

</style>



// WEBPACK FOOTER //
// IntroView.vue.vue?74438328